export default __webpack_public_path__ + "static/media/wealth_raffle_turn_icon3.0ddf3248.png";